import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "adjustmentNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.ADJUSTMENT.fullString,
    hasInputLabel: true,
  },
  {
    apiName: "transferNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.TRANSFER.fullString,
    hasInputLabel: true,
  },
];
